import request from '@/api/request'

export function recordVisit(data) {
  return request({
    url: '/api/visit/record',
    method: 'post',
    data
  })
}
